export default "__VITE_ASSET__9el$yCIz__"